// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React from "react";
import { useSelector } from "react-redux";

import { getGroup } from "src/reducers";
import Icon from "src/icons";
import Tooltip from "src/components/Tooltip";

import type { GroupId } from "src/types";

type Props = {
  groupId: GroupId
};

const Group = ({ groupId }: Props) => {
  const group = useSelector(({ app }) => getGroup(app, groupId)) || {};
  const groupSize = (group?.members ?? []).length;

  return (
    <Tooltip
      placement="top"
      title={group?.title || ""}
      description={`${groupSize || 0} ${
        groupSize === 1 ? i18n.t(k.MEMBER) : i18n.t(k.MEMBERS)
      }`}
    >
      <div>
        <Icon
          type="groupAvatar"
          text={group?.title || ""}
          size="xs"
          photoUrl={group?.photoUrl || ""}
          id={groupId}
        />
      </div>
    </Tooltip>
  );
};

export default Group;
